// Função isolada para testes
export const getInputMobileType = (type) => {
  switch (type) {
    case "numeric":
      return "decimal";
    case "text":
      return "text";
    default:
      return "text";
  }
};
